/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { Card, CardBody, Col, Container, Button, UncontrolledTooltip } from 'reactstrap'
import { connect } from 'react-redux';
import DataTable from 'react-data-table-component'

import Breadcrumbs from '../CommonElements/Breadcrumbs'

import { getQueues as getQueuesAction } from '../ReduxToolkit/Reducers/queues';
import { useNavigate } from 'react-router-dom';

function Queues({ getQueues, queues, totalQueues, selectedFilters }) {
  const navigate = useNavigate();
  const [page, setPage] = useState(selectedFilters?.page || 1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [tableData, setTableData] = useState(queues[page] || []);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (page) {
      // if (queues[page] && queues[page]?.length === itemsPerPage) {
      //   setTableData(queues[page]);
      //   setIsLoading(false);
      // } else {
      _getTableData();
      // }
    }
  }, [page]);

  useEffect(() => {
    if (queues[page]) {
      setTableData(queues[page]);
    }
  }, [queues]);

  useEffect(() => {
    _getTableData();
  }, [itemsPerPage]);

  useEffect(() => {
    if ((tableData?.length > 0 && tableData?.length !== 10) || itemsPerPage !== 10) {
      _getTableData();
    }
  }, [itemsPerPage]);

  const _getTableData = async (hideLoader = false) => {
    if (!hideLoader) setIsLoading(true);
    await getQueues(page, itemsPerPage);
    setIsLoading(false);
  };

  const _handleItemPerPageSelect = async (count) => {
    setPage(1);
    setItemsPerPage(count);
  };

  return (
    <div className='page-body'>
      <Breadcrumbs pageTitle='Queues' parent='Home' title='Queues Table' />
      <Container fluid>
        <Col sm={12}>
          <Card>
            <CardBody>
              {/* <Row className="align-items-center justify-content-between">
                <Col xs="auto" className='d-flex flex-row gap-3 align-items-center'>
                  {selectedRowsData?.selectedCount > 0 && (
                    <>
                      <Input type="select" style={{ width: '150px' }} onChange={handleAssignBrandsToCompany}>
                        <option value={null}>Select</option>
                        {companies?.map((company) => (
                          <option key={company?.id} value={company?.id}>
                            {company?.name}
                          </option>
                        ))}
                      </Input>
                      <Button outline color='primary' onClick={() => setConfirmationModal(true)}><Trash /></Button>
                    </>
                  )}
                  <button style={{ border: 'none', outline: 'none', padding: '10px 15px', borderRadius: '7px' }} onClick={() => navigate(`/import-data/brand`)}>
                    + Import Brand
                  </button>

                  <button onClick={() => setManuallModal(true)} style={{ border: 'none', outline: 'none', padding: '10px 15px', borderRadius: '7px', color: 'white', backgroundColor: 'black' }}>
                    Add Brand Manually
                  </button>
                </Col>
                <Col xs="auto" className='d-flex flex-row gap-3 align-items-center'>
                  <Label className='mb-0'>{'Search'}:</Label>
                  <Input type="text" placeholder='Search name or domain...' value={searchTerm} onChange={_handleSearchTextChange} />
                </Col>
              </Row> */}
              <div className="table-responsive mt-3">
                <DataTable
                  striped
                  pagination
                  data={tableData}
                  className="display"
                  paginationServer
                  progressPending={isLoading}
                  paginationTotalRows={totalQueues}
                  paginationPerPage={itemsPerPage}
                  paginationDefaultPage={page}
                  onChangePage={(newPage) => setPage(newPage)}
                  onChangeRowsPerPage={_handleItemPerPageSelect}
                  columns={[
                    {
                      name: "Batch ID",
                      cell: (row) => {
                        const tooltipId = `brand-tooltip-${row?.id}`;
                        return (
                          <>
                            <h6
                              id={tooltipId}
                              style={{
                                display: "-webkit-box",
                                overflow: "hidden",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                              }}
                            >
                              {row?.batch_id}
                            </h6>
                            <UncontrolledTooltip placement="top" target={tooltipId}>
                              {row?.batch_id}
                            </UncontrolledTooltip>
                          </>
                        );
                      },
                    },
                    {
                      name: "From",
                      cell: (row) => {
                        return (
                          <>
                            <h6
                              style={{
                                display: "-webkit-box",
                                overflow: "hidden",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                              }}
                            >
                              {row?.server}
                            </h6>
                          </>
                        );
                      },
                    },
                    {
                      name: "Type",
                      cell: (row) => {
                        return (
                          <>
                            <h6
                              style={{
                                display: "-webkit-box",
                                overflow: "hidden",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                              }}
                            >
                              {row?.type}
                            </h6>
                          </>
                        );
                      },
                    },
                    {
                      name: "Added At",
                      cell: (row) => {
                        return (
                          <>
                            <h6
                              style={{
                                display: "-webkit-box",
                                overflow: "hidden",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                              }}
                            >
                              {formatDate(row?.added_at)}
                            </h6>
                          </>
                        );
                      },
                    },
                    {
                      name: "Action",
                      cell: (row) => {
                        return (
                          <>
                            <Button
                              color='primary'
                              onClick={() => navigate('/queue', { state: { queue: row } })}
                              style={{
                                display: "-webkit-box",
                                overflow: "hidden",
                                WebkitBoxOrient: "vertical",
                                WebkitLineClamp: 2,
                              }}
                            >
                              View Details
                            </Button>
                          </>
                        );
                      },
                    },
                  ]}
                />
              </div>
            </CardBody>
          </Card>
        </Col>
      </Container>
    </div>
  )
}

const formatDate = (dateString) => {
  if (!dateString) return '--';
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleString('en-US', { month: 'short' });
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
};

const mapStateToProps = (state) => ({
  totalQueues: state.queues.totalQueues,
  selectedFilters: state.queues.selectedFilters,
  queues: state.queues.queues,
});

const mapDispatchToProps = {
  getQueues: getQueuesAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(Queues);
